import "./Home.scss";

// code imports
import React, { Suspense } from 'react';
import Header from '../../common/Header/Header';
import Section1 from './Section1';
import Section2 from './Section2';
// import Section3 from './Section3';
// import Section4 from './Section4';
import Footer from '../../common/Footer/Footer';
import usePageMeta from '../../common/usePageMeta';
import SEO_META from "../../../seoMeta.json";
import PavilionNudge from '../../common/UI_Elements/PavilionNudge';

// below-the-fold gallery (swiper + lightbox) loads after the first paint
const Section5 = React.lazy(() => import('./Section5'));

/**
 * Renders the Homepage
 *
 * @returns {React.Component}
 */
function Home() {
  usePageMeta(SEO_META["/"]);

  return (
    <div className="Home">
        <Header variant="mobile" />

        <Section1 />
        <Section2 />
        {/* Section3 ("Discover the best") hidden for now */}
        {/* <Section3 /> */}
        {/* Section4 ("What our users say") hidden for now */}
        {/* <Section4 /> */}
        <Suspense fallback={null}>
            <Section5 />
        </Suspense>

        {/* extra descriptive copy for search engines (SEO audit: thin content) */}
        <div className="seo-hidden">
          <h2>Hitwicket™ Cricket Game</h2>
          <p>
            Experience the thrill of cricket with Sachin Tendulkar and Hitwicket! Join 20M+ players worldwide and discover a unique style of cricket gameplay in one of the top-grossing sports games on Android, proudly made in India.
          </p>
          <p>
            Enjoy the excitement of cricket with the iconic commentary of Harsha Bhogle, bringing every match to life!
          </p>
          <p>
            Be the Owner, Coach, and Captain of your very own superpowered cricket team. Recruit from a pool of 50+ unique players, participate in exciting player auctions, and build your dream squad. Train and customise your players with exciting skins and equipment, enhance their performance with powerful upgrades, and craft winning strategies with your playing 11.
          </p>
          <p>
            Whether you love building the perfect squad or outsmarting your opponents on the field, Hitwicket offers a whole new way to experience cricket.
          </p>
        </div>

        <Footer />

        <PavilionNudge />
    </div>
  );
}

export default Home;
